import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "common/hooks";
import Loader from "@/components/common/Loader";
import { useGetInTouchModal } from "@/hooks/useGetInTouchModal";

export const Route = createFileRoute("/get-in-touch")({
  component: GetInTouch,
});

function GetInTouch() {
  const navigate = useNavigate({ from: "/" });
  const { isLoading, isFetching } = useAuth();
  const isAuthLoading = isLoading || isFetching;

  const { showGetInTouchModal } = useGetInTouchModal();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      showGetInTouchModal();

      setTimeout(() => {
        //redirect to home page
        navigate({ to: "/" });
      }, 500);
    }
  }, [isFetching, isLoading, navigate, showGetInTouchModal]);

  return <>{isAuthLoading && <Loader />}</>;
}
